module.exports = __webpack_public_path__ + "img/registerimage5.d659448c.png";